import { GenericService } from '@/services/api/generic.service';
import { InadequateReason } from '@/models';

export class InadequateReasonService extends GenericService<InadequateReason> {
  constructor() {
    super('v1/inadequate-reasons');
  }
}
